import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { StyledRefundModal } from '../../../components/managers/reports/apartment_cashflow_table/RefundModal.styled';

const ConfirmationModal = ({ show, onHide, error, startCampaign }) => {
    const { t } = useTranslation();

    return (
        <StyledRefundModal
            centered
            show={show}
            onHide={onHide}
        >
            <Modal.Header>
                <Modal.Title>{error ? t('autoCampaign.errorPopUp.title') : t('autoCampaign.confirmPopUp.title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="info-text">
                    <div>{error ? t('autoCampaign.errorPopUp.startNew') : t('autoCampaign.confirmPopUp.sure')}</div>
                </div>

                <div className="buttons-container">
                    <button
                        className="bllink-button"
                        onClick={startCampaign}
                    >
                        {t('reports.refund.btns.yes')}
                    </button>

                    <button
                        onClick={onHide}
                        className="btn_12"
                    >
                        {t('reports.refund.btns.no')}
                    </button>
                </div>
            </Modal.Body>
        </StyledRefundModal>
    )
};

export default ConfirmationModal;